import React, { createContext, useEffect, useState, useRef } from "react";
import { getAllAppointmentsProviders } from "../actions";
import { ProviderResponse } from "../types/common-types";
import { useLocation } from "react-router-dom";
import { addNotification } from "../store/slices/ui-slice";
import { v4 as uuid } from "uuid";
import { useAppDispatch } from "../store/hooks";

interface GlobalContextType {
  providersAppointmentData: ProviderResponse[];
  setProvidersAppointmentData: (data: any) => void;
}

export const GlobalContext = createContext<GlobalContextType>({
  providersAppointmentData: [],
  setProvidersAppointmentData: () => {},
});

export const GlobalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [providersAppointmentData, setProvidersAppointmentData] = useState<
    ProviderResponse[]
  >([]);

  const hasFetched = useRef(false);
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const userAppToken = localStorage.getItem("userAppToken");
    const ctToken = localStorage.getItem("ctToken");

    const isRescheduleRoute =
      location.pathname === "/user-app/reschedule-confirmation";
    if (hasFetched.current || (!userAppToken && !ctToken) || isRescheduleRoute)
      return;

    hasFetched.current = true;

    getAllAppointmentsProviders()
      .then((resp) => {
        setProvidersAppointmentData(resp?.data?.data || []);
      })
      .catch((error) => {
        console.error("Failed to fetch providers' appointments:", error);
        dispatch(
          addNotification({
            id: uuid(),
            type: "error",
            message:
              error?.response?.data?.message ||
              error.message ||
              "Failed to fetch appointment providers",
          })
        );
      });
  }, []);

  return (
    <GlobalContext.Provider
      value={{ providersAppointmentData, setProvidersAppointmentData }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
